import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { DebugService } from '../services/utils/debug.service';

@Injectable()
export class DebugInterceptor implements HttpInterceptor {

    constructor(
        private debug: DebugService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (environment.production)
            return next.handle(req);

        const start = performance.now();

        return of(req.clone())
            .pipe(
                switchMap(x => next.handle(x)),
                tap(x => {
                    if (x instanceof HttpResponse)
                        this.debug.printHttpResponseBody(x, start)
                })
            );
    }

}